import {
  ConditionName,
  RangeConditionName,
  PeriodConditionName,
  setError,
  clearError,
  CHECK_CONDITION_NAMES,
  RADIO_CONDITION_NAMES,
} from '../actions'
import { Conditions, CONDITION_ITEMS } from '../constants/conditions'
import parse from 'date-fns/parse'
import { select, put } from 'redux-saga/effects'
import { State } from '../reducers'
import compareDesc from 'date-fns/compareDesc'

export const validate = (conditions: Conditions): ConditionName[] => [
  ...validateRange(conditions, ['totalFunding', 'valuation', 'employees']),
  ...validatePeriod(conditions, [
    'established',
    'ipoed',
    'lastFundraised',
    'statusUpdated',
  ]),
  ...validateSelected(conditions),
]

function validateRange(
  conditions: Conditions,
  keys: RangeConditionName[]
): ConditionName[] {
  let errors: ConditionName[] = []
  for (let key of keys) {
    const cond = conditions[key]
    if (!cond) {
      continue
    }
    const { from, to } = cond
    if (
      from === null ||
      to === null ||
      from === undefined ||
      to === undefined
    ) {
      continue
    }
    if (from > to) {
      errors.push(key)
    }
  }
  return errors
}

function validatePeriod(
  conditions: Conditions,
  keys: PeriodConditionName[]
): ConditionName[] {
  let errors: ConditionName[] = []
  for (let key of keys) {
    const cond = conditions[key]
    if (!cond) {
      continue
    }
    const { from, to } = cond
    if ((from && !isValidFormat(from)) || (to && !isValidFormat(to))) {
      errors.push(key)
    }
    if (from && to && !isValidPeriod(from, to)) {
      errors.push(key)
    }
  }
  return errors
}

const isValidFormat = (s: string) => {
  const dateRegex = /^\d{4}\-(0?[1-9]|1[0-9])\-(0?[1-9]|[12][0-9]|3[01])$/
  return s.match(dateRegex)
}

const isValidPeriod = (from: string, to: string) =>
  compareDesc(
    parse(from, 'yyyy-MM-dd', new Date()),
    parse(to, 'yyyy-MM-dd', new Date())
  ) >= 0

function validateSelected(conditions: Conditions) {
  const keys = [...CHECK_CONDITION_NAMES, ...RADIO_CONDITION_NAMES]
  return keys.filter((name) => {
    const selected = conditions[name] || []
    const options = CONDITION_ITEMS[name].options
    const errorSelected = selected.filter((select) => !options[select])
    return errorSelected.length
  })
}

export function* validateConditions() {
  // @ts-ignore
  const { selected } = yield select<State>((state) => ({
    selected: {
      ...state.condition.selected,
      statusUpdated: state.statusCondition.statusUpdated,
    },
  }))
  const errors = validate(selected)
  // @ts-ignore
  errors.length > 0 ? yield put(setError(errors)) : yield put(clearError())
}
